import { fetchWithToken } from "@/services"

const PLACE_ORDER_UPSELL = `
mutation placeOrderUpsellOffers($order_id: Int!, $selected_offers: [String]!) {
  placeOrderUpsellOffers(order_id: $order_id, selected_offers: $selected_offers){
     payment {
            account
            account_note
            account_number
            bank
            bank_id
            bank_logo
            qr_logo
        }
        orderV2 {
            entity_id
            order_number
            grand_total {
                currency
                value
            }
        }
  }
}`

export const placeOrderUpsellOffers = async ({order_id, selected_offers}: {order_id: number, selected_offers: string[]}) => {
  try {
    const response = await fetchWithToken({
      query: PLACE_ORDER_UPSELL,
      variables: {
        order_id: Number(order_id),
        selected_offers: selected_offers,
      },
    }).then((res) => res?.payload)
    const data = response?.data?.placeOrderUpsellOffers as IOrderInfoPlaceOrder
    if (!data) return { status: 'error', message: response?.errors?.[0]?.message, data: null }
    return { status: 'success', message: '', data: data }
  } catch (err) {
    return { status: 'error', message: "something's wrong", data: null  }
  }
}
